import {createSvgIcon} from '../../../../icons/create-svg-icon';

export const ColorIcon = createSvgIcon(
  <path
    stroke="#E0E0E0"
    d="M24,44c-7.168,0-13-5.816-13-12.971C11,24,24,4,24,4s13,20,13,27.029C37,38.184,31.168,44,24,44z"
  />
);
